import { View, Image, StyleSheet, ViewStyle } from "react-native";
import React from "react";
import { MixState, MsgProgress, Target } from "../store/MixReducer";
import { useAppSelector } from "../../../store";
import { MessageScreen } from "./MessageScreen";
import { Card, Content } from "../../../components";
import { opac } from "../utils/messageUtils";
import { Row } from "./MixScreen";
import {
  FieldGenerator,
  FieldMixed,
  FieldReceived,
  FieldResult,
  FieldSecret,
} from "../../exchange/components/MixFields";
import { Picker } from "../../exchange/components/MixButtons";

export const MixChatScreen = () => {
  return (
    <Content style={{ flexDirection: "row", height: "100%" }}>
      <PersonStore target="alice" style={{ flex: 2 }} />
      <MessageScreen style={{ flex: 3 }} />
      <PersonStore target="bob" style={{ flex: 2 }} />
    </Content>
  );
};

export interface PersonStoreInterface {
  target: Target;
  style?: ViewStyle;
}

export const PersonStore = ({ target, style }: PersonStoreInterface) => {
  const msgProgress: MsgProgress = useAppSelector(
    (state) => state.mix.msgProgress
  );
  const mix: MixState = useAppSelector((state) => state.mix);

  const styles = StyleSheet.create({
    personCard: {
      height: "100%",
      backgroundColor: target === "bob" ? "#7E2A0C10" : "#FEF9C230",
      flexDirection: "column",
    },
    player: {
      flex: 5,
    },
    playerColumn: {
      flexDirection: "column",
      flex: 2,
    },
    playerImage: {
      flex: 1,
    },
    generator: { flex: 1, opacity: opac(msgProgress.generatorShown[target]) },
    secret: { flex: 1, opacity: opac(msgProgress.secretsShown) },
    mix: { flex: 2, opacity: opac(msgProgress.mixBtnsShown) },
    received: { flex: 2, opacity: opac(msgProgress.hasOtherMix[target]) },
    result: { flex: 3, opacity: opac(msgProgress.resultsShown) },
  });

  return (
    <Card style={[styles.personCard, style]}>
      <Row target={target} style={styles.player}>
        <Image
          style={styles.playerImage}
          source={require(`../../../../assets/${target}.png`)}
          resizeMode="contain"
        />
        <View style={styles.playerColumn}>
          <FieldGenerator style={styles.generator} />
          <View style={styles.secret}>
            {mix[target].hasPicked ? (
              <FieldSecret target={target} />
            ) : (
              <Picker target={target} disabled={false} />
            )}
          </View>
        </View>
      </Row>
      <View style={styles.mix}>
        <FieldMixed target={target} />
      </View>
      <View style={styles.received}>
        <FieldReceived target={target} />
      </View>
      {/* TODO Views hier nötig? */}
      <View style={styles.result}>
        <FieldResult target={target} />
      </View>
    </Card>
  );
};
